import * as Yup from "yup";

// ✅ Mobile Number
export const mobileValidation = Yup.string()
    .required("Mobile number is required")
    .matches(/^[6-9]\d{9}$/, "Enter valid 10-digit mobile number");

// ✅ Email
export const emailValidation = Yup.string()
    .trim()
    .required("Email is required")
    .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Enter a valid email address"
    );

// ✅ Aadhaar
export const aadhaarValidation = Yup.string()
    .required("Aadhaar is required")
    .matches(/^\d{12}$/, "Aadhaar must be 12 digits");

// ✅ Only Text (alphabets + spaces)
export const textValidation = Yup.string()
    .required("This field is required")
    .matches(/^[A-Za-z\s]+$/, "Only alphabets allowed");

// ✅ Only Numbers
export const numberValidation = Yup.string()
    .required("This field is required")
    .matches(/^\d+$/, "Only numbers allowed");

// ✅ Required Select
export const selectValidation = Yup.string()
    .required("Please select an option");

// ✅ Date (no future)
export const dateValidation = Yup.date()
    .required("Date is required")
    .max(new Date(), "Future date not allowed");

export const pincodeValidation = Yup.string()
    .required("Pincode is required")
    .matches(/^[1-9][0-9]{5}$/, "Enter valid 6-digit pincode");